'use strict';

const errorNotificationDialog = require('../components/errorNotificationDialog');
const { changeFavoriteButton, initializeFavoriteButton } = require('../components/favoriteHandle');
const { appendToUrl } = require('../utils/commonHelper');

module.exports = function () {
    // Initialize favorite button status via AJAX on Cart page load
    $('.button-favorite').each(function () {
        initializeFavoriteButton($(this));
    });

    $('.button-favorite').on('click', function (e) {
        e.preventDefault();
        var button = $(this);
        var productID = $(this).attr('data-pid');
        var uuid = $(this).attr('data-uuid');
        var url = $(this).attr('data-action-url');
        var action = $(this).attr('data-action');
        var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
        var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        var data = {
            pid: productID,
            uuid: uuid,
            optionId: optionId,
            optionVal: optionVal
        };

        if (!url || !productID) {
            return;
        }

        if (action == "Wishlist-AddProduct") {
            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data,
                success: function (data) {
                    changeFavoriteButton(data, button);
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        errorNotificationDialog(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        } else if (action == "Wishlist-RemoveProduct") {
            url = appendToUrl(url, data);

            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    changeFavoriteButton(data, button);
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        errorNotificationDialog(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });
};
